<template>
    <div>
        <PublicViewStatement />
    </div>
</template>

<script>
import PublicViewStatement from '@/components/PublicStatement'
export default {
    components: {
        PublicViewStatement
    }
}
</script>